import React from 'react'
import PropTypes from 'prop-types'
import { Columns, Column } from '@resurs/midas-react'
import { LocaleState } from '@merchant-portal/merchant-portal-base'
import StatusBoard from './StatusBoard'
import { getText } from '../../../internal/TextLabels'

const formatFloat = (value, language) => {
  if (!!value || value === 0) {
    return parseFloat(value).toLocaleString(language)
  }
  return '-'
}

class StatisticsStatusBoard extends React.PureComponent {
  render() {
    const { status, scope, timespan, customStart } = this.props
    const { language } = this.context

    const prevValue = formatFloat(
      status && status.previousNumberOfSales,
      language,
    )
    const prevAmount = formatFloat(
      status && status.previousTotalSales,
      language,
    )
    const currentAmount = formatFloat(status && status.numberOfSales, language)
    const currentValue = formatFloat(status && status.totalSales, language)
    const amountPosition = formatFloat(
      status && status.numberOfSalesPosition,
      language,
    )
    const valuePosition = formatFloat(
      status && status.totalSalesPosition,
      language,
    )
    const prevNbrOfApplications = formatFloat(
      status && status.previousNumberOfApplications,
      language,
    )
    const currentNbrOfApplications = formatFloat(
      status && status.numberOfApplications,
      language,
    )
    const nbrOfApplicationsPosition = formatFloat(
      status && status.numberOfApplicationsPosition,
      language,
    )

    let numberOfSalesComment
    let totalSalesComment
    let totalApplicationsComment

    switch (timespan) {
      case (customStart && timespan) || '':
        numberOfSalesComment = ''
        totalSalesComment = ''
        totalApplicationsComment = ''
        break
      case 'MONTH':
        numberOfSalesComment = getText(
          'statistics.statusBoard.previousNumberMonth',
          prevValue,
        )
        totalSalesComment = getText(
          'statistics.statusBoard.previousTotalSalesMonth',
          prevAmount,
        )
        totalApplicationsComment = getText(
          'statistics.statusBoard.previousNumberMonth',
          prevNbrOfApplications,
        )
        break
      case 'WEEK':
        numberOfSalesComment = getText(
          'statistics.statusBoard.previousNumberWeek',
          prevValue,
        )
        totalSalesComment = getText(
          'statistics.statusBoard.previousTotalSalesWeek',
          prevAmount,
        )
        totalApplicationsComment = getText(
          'statistics.statusBoard.previousNumberWeek',
          prevNbrOfApplications,
        )
        break
      default:
        numberOfSalesComment = getText(
          'statistics.statusBoard.previousNumberYear',
          prevValue,
        )
        totalSalesComment = getText(
          'statistics.statusBoard.previousTotalSalesYear',
          prevAmount,
        )
        totalApplicationsComment = getText(
          'statistics.statusBoard.previousNumberYear',
          prevNbrOfApplications,
        )
    }

    const positionTranslation =
      scope === 'representative'
        ? 'statistics.statusBoard.storePosition'
        : 'statistics.statusBoard.sellerPosition'

    return (
      <Columns>
        <Column col4>
          <StatusBoard
            data={getText(
              'statistics.statusBoard.numberOf',
              currentNbrOfApplications,
            )}
            title={getText('statistics.statusBoard.numberOfApplicationsTitle')}
            comment={totalApplicationsComment}
            footer={getText(positionTranslation, nbrOfApplicationsPosition)}
          />
        </Column>
        <Column col4>
          <StatusBoard
            data={getText('statistics.statusBoard.numberOf', currentAmount)}
            title={getText('statistics.statusBoard.numberOfSalesTitle')}
            comment={numberOfSalesComment}
            footer={getText(positionTranslation, amountPosition)}
          />
        </Column>
        <Column col4>
          <StatusBoard
            data={getText('statistics.statusBoard.totalSales', currentValue)}
            title={getText('statistics.statusBoard.totalSalesTitle')}
            comment={totalSalesComment}
            footer={getText(positionTranslation, valuePosition)}
          />
        </Column>
      </Columns>
    )
  }
}

StatisticsStatusBoard.propTypes = {
  status: PropTypes.object.isRequired,
  timespan: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
  customStart: PropTypes.bool.isRequired,
}

StatisticsStatusBoard.contextType = LocaleState

export default StatisticsStatusBoard
